module.exports = __webpack_public_path__ + "static/star-63e89ac381e6507184292bb2b64de2bf.svg";